import { getDeviceLabelById } from '../../../react/features/base/devices/functions.web';
import { toState } from '../../../react/features/base/redux/functions';
import { getUserSelectedMicDeviceId } from '../../../react/features/base/settings/functions.web';
import { getLocalJitsiAudioTrack } from '../../../react/features/base/tracks/functions.any';
import { isNoiseSuppressionEnabled } from '../../../react/features/noise-suppression/functions';
import { sendStatsToKibana } from '../analytics/kibana/actions';
import { KIBANA_MESSAGES } from '../analytics/kibana/constants';
import { DEFAULT } from './constants';
export function getNewNoiseSuppressionType(stateful) {
    const state = toState(stateful);
    // @ts-ignore
    const { newNoiseSuppressionType = DEFAULT } = state['wildix/customStorageSettings'];
    return newNoiseSuppressionType;
}
export function sendAudioAnalytics({ dispatch, state, title, noiseType, isNoiseEnabled, audioJitsiTrack = null, deviceList }) {
    const audioTrack = audioJitsiTrack ?? getLocalJitsiAudioTrack(state);
    const objectSend = {
        noiseSuppressionType: noiseType ?? getNewNoiseSuppressionType(state),
        isNoiseSuppressionEnabled: isNoiseEnabled ?? isNoiseSuppressionEnabled(state)
    };
    if (audioTrack) {
        const isAudioMuted = audioTrack?.track?.muted;
        const deviceId = getUserSelectedMicDeviceId(state) ?? '';
        objectSend.deviceName = getDeviceLabelById(state, deviceId, 'audioInput');
        objectSend.trackMuted = isAudioMuted;
    }
    else {
        objectSend.trackMuted = true;
    }
    if (deviceList) {
        objectSend.deviceList = deviceList;
    }
    console.warn(title, objectSend, 'objectSend');
    dispatch(sendStatsToKibana([objectSend], KIBANA_MESSAGES.audioAnalytics(title)));
}
